import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { IoCheckmarkCircleSharp } from "react-icons/io5";

const PopupSuccess = ({ isClose, successMsg }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsAnimating(true), 10); 
  }, []);

  const modalOverlayStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    zIndex: 1000,
    opacity: isAnimating ? 1 : 0,
    transition: "opacity 0.3s ease-in-out",
  };

  const modalContentStyle = {
    position: "relative",
    border: "2px solid rgb(204, 204, 204)",
    background: "rgb(255, 255, 255)",
    borderRadius: "8px",
    outline: "none",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 10px",
    textAlign: "center",
    maxWidth: "400px",
    width: "100%",
    padding: "20px",
    marginTop: "20px",
    opacity: isAnimating ? 1 : 0,
    transform: isAnimating ? "translateY(0)" : "translateY(-50%)",
    transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  };

  const closeButtonStyle = {
    padding: "5px 17px",
    backgroundColor: "green",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "5px",
  };

  const iconStyle = { fontSize: "22px", color: "green", margin: "10px" };
  const alertStyle = { fontWeight: 600, fontSize: "15px", color: "green" };

  return (
    <Modal isOpen={true} style={{ overlay: modalOverlayStyle, content: modalContentStyle }}>
      <IoCheckmarkCircleSharp style={iconStyle} />
      <span style={alertStyle}>{successMsg || "SUCCESS"}</span>
      <br />
      <button onClick={isClose} style={closeButtonStyle}>
        OK
      </button>
    </Modal>
  );
};

PopupSuccess.propTypes = {
  isClose: PropTypes.func.isRequired,
  successMsg: PropTypes.string,
};

export default PopupSuccess;
